import type { TemplateFormChangedEvent } from '@/interfaces/TailoredWidget.interface';
import { Directive, input, output } from '@angular/core';

@Directive()
export abstract class AbstractTailoredWidgetTemplateEditor<T extends {}> {
    formInputs = input<T>();
    config = output<TemplateFormChangedEvent>();
}
